import Flux from 'lib/flux';
import PricingConstants from 'constants/pricing';
import PricingService from 'services/pricing';
import debounce from 'throttle-debounce/debounce';

export default Flux.createActionCreator({
  preview: debounce(400, function (params = null) {
    const _this = this;
    const onFullfilled = function (resp) {
      _this.dispatchAction(PricingConstants.PREVIEW_COMPLETED, resp);
    };
    const onRejected = function (_resp, _textStatus, _error) {
      _this.dispatchAction(PricingConstants.PREVIEW_FAILED);
    };

    this.dispatchAction(PricingConstants.PREVIEW);
    PricingService.buildPreview(params).then(onFullfilled, onRejected);
  }),

  saveFormFields(fieldData) {
    this.dispatchAction('FORM_DATA_SENT', fieldData);
  },
});
